import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';

// API endpoints
const API_LIST = '/tags';
const API_DETAIL = (id: number) => `/tags/${id}`;

export interface Tags {
  id: number;
  name?: string;
  description?: string;
  color?: string;
  tagCreatedBy?: number;
  tagUpdatedBy?: number;
}

export const useTags = (searchParams?: string) => {
  const queryString = searchParams ? `?searchParams=${encodeURIComponent(searchParams)}` : '';
  const { data, error, isLoading, mutate } = useSWR<Tags[]>(
    `${API_LIST}${queryString}`,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  );

  return {
    data: data || [],
    tags: data || [],
    isLoading,
    isError: error,
    mutate,
  };
};

export const useTag = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<Tags>(
    id ? API_DETAIL(id) : null,
    fetcher,
    {
      revalidateOnFocus: true,
    }
  );

  return {
    data: data,
    tag: data,
    isLoading,
    isError: error,
    mutate,
  };
};
